/**
 * index.js contains the logic to expose the component, in this case it simply exposes
 * the SideBar.component, in some complex cases this might contain the logic to
 * expose the components conditionally.
 */

import SideBar from './SideBar.component';

export default SideBar;
